import React, { useEffect, useState } from 'react';
import { Link, navigate } from 'gatsby';

import { Container } from '../Container';

import styles from './navigation.module.css';

export function Navigation({ location }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToContact = event => {
    event.preventDefault();

    if (location.pathname === '/') {
      setMobileMenuOpen(false);
      document.querySelector('#contact').scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/#contact');
    }
  };

  const scrollToBook = event => {
    event.preventDefault();

    if (location.pathname === '/') {
      setMobileMenuOpen(false);
      document.querySelector('#book').scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/#book');
    }
  };

  const scrollToHome = event => {
    event.preventDefault();

    if (location.pathname === '/') {
      setMobileMenuOpen(false);
      window.scroll({ behavior: 'smooth', left: 0, top: 0 });
    } else {
      navigate('/');
    }
  };

  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [mobileMenuOpen])

  return (
    <>
    <nav className={`sticky top-0 bg-white z-10 ${!mobileMenuOpen && 'border-b-4'} border-main md:border-gray-300 h-20`}>
      <Container className="hidden md:flex items-stretch justify-end flex-wrap h-20">
        <a
          className={`text-greyMedium mr-2 p-6 font-bold border-b-4 hover:bg-gray-200 hover:border-main ${location.pathname === '/' ? 'border-main text-main' : ''}`}
          href="/"
          onClick={scrollToHome}
        >
          Home
        </a>
        <Link
          activeClassName="border-main text-main"
          className="text-greyMedium mr-2 p-6 font-bold border-b-4 hover:bg-gray-200 hover:border-main"
          partiallyActive={true}
          to="/research"
        >
          Research
        </Link>
        <a
          className="text-greyMedium mr-2 p-6 font-bold border-b-4 hover:bg-gray-200 hover:border-main"
          href="#contact"
          onClick={scrollToContact}
        >
          Contact
        </a>
        <a
          className="p-6 bg-secondary text-greyDark font-bold border-b-4 border-secondaryDark hover:bg-secondaryDark hover:text-white"
          href="#book"
          onClick={scrollToBook}
        >
          Book an appointment
        </a>
      </Container>
      <Container className="md:hidden flex items-center px-5 h-20">
        <button
          className={`h-10 w-10 outline-none overflow-hidden whitespace-no-wrap ${styles.menuToggleButton} ${mobileMenuOpen && styles.isOpen}`}
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          {`${mobileMenuOpen ? 'Close' : 'Open'} navigation menu`}
        </button>
      </Container>
    </nav>
    {mobileMenuOpen
      ? (
          <div className={`fixed top-5r bottom-0 right-0 left-0 z-20 bg-white overflow-auto`}>
            <a
              className={`block text-greyMedium text-2xl p-6 border-l-8 border-transparent ${location.pathname === '/' ? 'border-main bg-mainLight' : ''}`}
              href="/"
              onClick={scrollToHome}
            >
              Home
            </a>
            <Link
              activeClassName="border-main bg-mainLight"
              className="block text-greyMedium text-2xl p-6 border-l-8 border-transparent"
              partiallyActive={true}
              to="/research"
            >
              Research
            </Link>
            <a
              className="block text-greyMedium text-2xl p-6 border-l-8 border-transparent"
              href="#contact"
              onClick={scrollToContact}
            >
              Contact
            </a>
            <a
              className="block bg-secondary text-2xl p-6 text-greyDark border-transparent border-l-8"
              href="#book"
              onClick={scrollToBook}
            >
              Book an appointment
            </a>
          </div>
        )
      : null
    }
    </>
  );
}
